module.exports = __webpack_public_path__ + "band_0.9591c410.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_0.png
// module id = UFgU
// module chunks = 0